// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"src_views_Bridge_Jitsi_vue":"0760f19d","src_views_Bridge_index_vue":"e8e6ff59","src_views_Layout_vue":"e730ca9f"}[chunkId] + ".js";
};